
export const BASEURLS = (path) => {
    return `https://satkartar.one/assets/ppc/${path}`;
}